var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headersFiltered,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var header = ref.header;
var item = ref.item;
var v = ref.value;
return [(header.getRoute)?_c('router-link',{attrs:{"to":header.getRoute(item)},domProps:{"textContent":_vm._s(v)}}):[_vm._v(" "+_vm._s(v)+" ")]]}},{key:"item.ates",fn:function(ref){
var v = ref.value;
return [(v)?_c('BTableItemAte',{attrs:{"data":v}}):_vm._e()]}},_vm._l((_vm.$scopedSlots),function(_,key){return {key:key,fn:function(props){return [_vm._t(key,null,null,props)]}}})],null,true)},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }